/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Such_Just_Nils_HurlInputs */

const es_such_just_nils_hurl = /** @type {(inputs: Such_Just_Nils_HurlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia sesion`)
};

const gl_such_just_nils_hurl = /** @type {(inputs: Such_Just_Nils_HurlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar sesión`)
};

const en_such_just_nils_hurl = /** @type {(inputs: Such_Just_Nils_HurlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in`)
};

/**
* | output |
* | --- |
* | "Sign in" |
*
* @param {Such_Just_Nils_HurlInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const such_just_nils_hurl = /** @type {((inputs?: Such_Just_Nils_HurlInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Such_Just_Nils_HurlInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_such_just_nils_hurl(inputs)
	if (locale === "en") return en_such_just_nils_hurl(inputs)
	return es_such_just_nils_hurl(inputs)
});